// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".typo-caption[data-v-735d98bc]{font-style:normal;font-weight:400;font-size:12px;line-height:140%}.typo-caption.is-strong[data-v-735d98bc]{font-weight:600}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
